module.exports = __webpack_public_path__ + "static/media/arrow-right-purple.47ab4733.svg";